import React, { useState } from 'react'
import { QuizScoringService } from '../../services/quiz/QuizScoringService'
import { BankQuestion } from '../../services/bankQuestionService_moi'

const ScoringTest: React.FC = () => {
  const [testResults, setTestResults] = useState<any[]>([])

  const runScoringTests = () => {
    console.log('🧪 Running scoring tests...')
    
    const testCases = [
      // Test case 1: Multiple Choice - Correct
      {
        name: 'TN - Correct (user=0, correct=A)',
        question: {
          id: 'test1',
          type: 'multiple_choice',
          cau_hoi: 'Test question 1',
          dap_an_dung: 'A',
          diem: 1
        } as BankQuestion,
        userAnswer: 0,
        expectedCorrect: true,
        expectedPoints: 1
      },
      
      // Test case 2: Multiple Choice - Wrong
      {
        name: 'TN - Wrong (user=1, correct=A)',
        question: {
          id: 'test2',
          type: 'multiple_choice',
          cau_hoi: 'Test question 2',
          dap_an_dung: 'A',
          diem: 1
        } as BankQuestion,
        userAnswer: 1,
        expectedCorrect: false,
        expectedPoints: 0
      },
      
      // Test case 3: Multiple Choice - No answer
      {
        name: 'TN - No answer (user=null, correct=A)',
        question: {
          id: 'test3',
          type: 'multiple_choice',
          cau_hoi: 'Test question 3',
          dap_an_dung: 'A',
          diem: 1
        } as BankQuestion,
        userAnswer: null,
        expectedCorrect: false,
        expectedPoints: 0
      },
      
      // Test case 4: Short Answer - Correct number
      {
        name: 'TL - Correct number (user="10", correct="10")',
        question: {
          id: 'test4',
          type: 'short_answer',
          cau_hoi: 'Test calculation',
          dap_an_dung: '10',
          diem: 2
        } as BankQuestion,
        userAnswer: '10',
        expectedCorrect: true,
        expectedPoints: 2
      },
      
      // Test case 5: Short Answer - Wrong number
      {
        name: 'TL - Wrong number (user="5", correct="10")',
        question: {
          id: 'test5',
          type: 'short_answer',
          cau_hoi: 'Test calculation',
          dap_an_dung: '10',
          diem: 2
        } as BankQuestion,
        userAnswer: '5',
        expectedCorrect: false,
        expectedPoints: 0
      },
      
      // Test case 6: Short Answer - Empty answer
      {
        name: 'TL - Empty answer (user="", correct="10")',
        question: {
          id: 'test6',
          type: 'short_answer',
          cau_hoi: 'Test calculation',
          dap_an_dung: '10',
          diem: 2
        } as BankQuestion,
        userAnswer: '',
        expectedCorrect: false,
        expectedPoints: 0
      },
      
      // Test case 9: Short Answer - Decimal with comma
      {
        name: 'TL - Decimal with comma (user="3,14", correct="3.14")',
        question: {
          id: 'test9',
          type: 'short_answer',
          cau_hoi: 'Tính giá trị π',
          dap_an_dung: '3.14',
          diem: 1
        } as BankQuestion,
        userAnswer: '3,14',
        expectedCorrect: true,
        expectedPoints: 1
      },
      
      // Test case 10: Short Answer - Scientific notation
      {
        name: 'TL - Scientific notation (user="1,5e-3", correct="0.0015")',
        question: {
          id: 'test10',
          type: 'short_answer',
          cau_hoi: 'Tính giá trị khoa học',
          dap_an_dung: '0.0015',
          diem: 1
        } as BankQuestion,
        userAnswer: '1,5e-3',
        expectedCorrect: true,
        expectedPoints: 1
      },
      
      // Test case 11: Short Answer - With unit
      {
        name: 'TL - With unit (user="4 cm", correct="4")',
        question: {
          id: 'test11',
          type: 'short_answer',
          cau_hoi: 'Tính biên độ dao động',
          dap_an_dung: '4',
          diem: 1
        } as BankQuestion,
        userAnswer: '4 cm',
        expectedCorrect: true,
        expectedPoints: 1
      },
      
      // Test case 7: True/False - Correct
      {
        name: 'DS - Correct (user=true, correct=true)',
        question: {
          id: 'test7',
          type: 'true_false',
          cau_hoi: 'Test true/false',
          dap_an_dung: true,
          diem: 1
        } as BankQuestion,
        userAnswer: true,
        expectedCorrect: true,
        expectedPoints: 1
      },
      
      // Test case 8: Multiple Choice - String comparison
      {
        name: 'TN - String (user="B", correct="B")',
        question: {
          id: 'test8',
          type: 'multiple_choice',
          cau_hoi: 'Test question',
          dap_an_dung: 'B',
          diem: 1
        } as BankQuestion,
        userAnswer: 'B',
        expectedCorrect: true,
        expectedPoints: 1
      }
    ]
    
    const results = testCases.map(testCase => {
      console.log(`\n🧪 Testing: ${testCase.name}`)
      
      // Create a mini quiz with just this question
      const questions = [testCase.question]
      const answers = { [testCase.question.id]: testCase.userAnswer }
      
      // Score the quiz
      const scoringResult = QuizScoringService.scoreQuiz(questions, answers, 60, 70)
      
      const actualCorrect = scoringResult.detailedAnalysis[0]?.isCorrect || false
      const actualPoints = scoringResult.detailedAnalysis[0]?.points || 0
      
      const passed = actualCorrect === testCase.expectedCorrect && actualPoints === testCase.expectedPoints
      
      const result = {
        name: testCase.name,
        passed,
        expected: {
          correct: testCase.expectedCorrect,
          points: testCase.expectedPoints
        },
        actual: {
          correct: actualCorrect,
          points: actualPoints
        },
        totalScore: scoringResult.score,
        percentage: scoringResult.percentage
      }
      
      console.log(`${passed ? '✅' : '❌'} ${testCase.name}:`, result)
      return result
    })
    
    setTestResults(results)
    
    const passedCount = results.filter(r => r.passed).length
    console.log(`\n📊 Test Summary: ${passedCount}/${results.length} tests passed`)
  }

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Quiz Scoring Test</h1>
      
      <div className="mb-6">
        <button
          onClick={runScoringTests}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Run Scoring Tests
        </button>
      </div>

      {testResults.length > 0 && (
        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Test Results</h2>
          
          <div className="grid grid-cols-1 gap-4">
            {testResults.map((result, index) => (
              <div
                key={index}
                className={`border rounded-lg p-4 ${
                  result.passed ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold">{result.name}</h3>
                  <span className={`px-2 py-1 rounded text-sm font-bold ${
                    result.passed ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'
                  }`}>
                    {result.passed ? 'PASS' : 'FAIL'}
                  </span>
                </div>
                
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <strong>Expected:</strong>
                    <div>Correct: {result.expected.correct ? 'Yes' : 'No'}</div>
                    <div>Points: {result.expected.points}</div>
                  </div>
                  <div>
                    <strong>Actual:</strong>
                    <div>Correct: {result.actual.correct ? 'Yes' : 'No'}</div>
                    <div>Points: {result.actual.points}</div>
                  </div>
                </div>
                
                <div className="mt-2 text-sm text-gray-600">
                  Total Score: {result.totalScore} | Percentage: {result.percentage}%
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded">
            <h3 className="font-semibold mb-2">Summary</h3>
            <p>
              <strong>{testResults.filter(r => r.passed).length}/{testResults.length}</strong> tests passed
            </p>
            <p className="text-sm text-gray-600 mt-1">
              Check browser console for detailed scoring logs
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ScoringTest